// extracted by mini-css-extract-plugin
export default {"wrapper":"WelcomeWrapper_wrapper__ok8Cs"};